import { decodeBase58, encodeBase58 } from '@spazious/dollhouse-utils';

import { SELECTOR_MAGIC_OFFSET } from './constants.js';

/**
 * Create a selector with a given index and parent selector
 * @param index
 * @param parentSelector
 * @param format
 * @returns
 */
export const create = <TFormat extends 'buffer' | 'string' = 'string'>(
  index: number,
  parentSelector: string | null,
  format: TFormat = 'string' as TFormat
): TFormat extends 'string' ? string : Buffer => {
  const arrayBuffer = new ArrayBuffer(2);
  const view = new DataView(arrayBuffer);
  view.setUint16(0, index + SELECTOR_MAGIC_OFFSET, true);

  const buffer = parentSelector
    ? Buffer.concat([decodeBase58(parentSelector), Buffer.from(arrayBuffer)])
    : Buffer.from(arrayBuffer);

  return format === 'string' ? encodeBase58(buffer) : (buffer as any);
};
